import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Trans, withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ScrollToTop from 'react-scroll-up';
import amplitude from 'amplitude-js';
import { withApollo } from '@apollo/client/react/hoc';
import { addMinutes, endOfDay, startOfDay, subDays } from 'date-fns';
import Icon from '../../components/Icon';
import RepositoriesList from './components/RepositoriesList';
import { SUPPORT_EMAIL, VCS_SLUG } from '../../constants/api';
import LoadingPlaceholder from '../../components/LoadingPlaceholder';
import { CLEAR_INVITED_ORGANIZATION } from '../../constants/ActionTypes';
import { IS_APP_CODEAC } from '../../constants/env';
import MaintenanceBanner from '../../components/MaintenanceBanner';
import Setup from '../../components/Setup';
import Layout from '../../containers/Layout';
import { registerWebhook } from '../../model/registerWebhook';
import { ghaNewInstallationLink } from '../../utils/ghaLinks';
import isRepositoryListEmpty from '../../utils/isRepositoryListEmpty';
import { timezoneOffsetCalculation } from '../../utils/timezoneOffsetCalculation';
import PrMetrics from '../PullRequestsPage/containers/PrMetrics';
import * as types from '../../constants/ActionTypes';
import ApiV2ModelContext from '../../contexts/ApiV2ModelContext';
import { Search } from './components/Search';
import { NoRepositories } from './components/NoRepositories';
import { Invitation } from './components/Invitation';
export class RepositoriesPage extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            shouldDispatch: true,
            loading: true,
            vcsRefetchSyncTimeout: null,
        };
        this.handleRegisterWebhook = (repositoryId) => {
            const { repositories, user, dispatch } = this.props;
            const vcsRepositories = repositories.list[VCS_SLUG[user.user.vcs]];
            let repository;
            for (const slug of Object.keys(vcsRepositories)) {
                if (vcsRepositories[slug].id === repositoryId) {
                    repository = vcsRepositories[slug];
                    break;
                }
            }
            if (!repository) {
                return;
            }
            this.props.dispatch({
                type: types.UPDATE_ACTIVE_BRANCH,
                payload: { repositoryId: repository.id, activeBranch: {} },
            });
            // @ts-expect-error TS2345: Argument of type 'Function' is not assignable to parameter of type '(_: Record<string, any>) => Promise<any>'.
            return registerWebhook(user, repository, dispatch, this.context, true);
        };
        this.handleScrollUp = () => {
            const eventName = 'scroll-up';
            amplitude.getInstance().logEvent(eventName);
        };
    }
    decideWhetherToLoadRepositories(props) {
        if (props.repositories.ghaInstallation) {
            this.fetchRepositoryList(true);
            props.dispatch({
                type: types.SET_GHA_INSTALLATION,
                payload: '',
            });
        }
        if (this.state.shouldDispatch && props.user.loggedIn /* && repositoriesCount === 0*/) {
            this.setState({ shouldDispatch: false });
            this.fetchRepositoryList();
        }
    }
    componentDidMount() {
        const { dispatch, user, history } = this.props;
        const isUserLogged = user.loggedIn;
        if (!isUserLogged) {
            history.replace('/login');
        }
        this.decideWhetherToLoadRepositories(this.props);
        dispatch({
            type: types.CLEAR_REPOSITORY,
        });
    }
    UNSAFE_componentWillReceiveProps(props) {
        this.decideWhetherToLoadRepositories(props);
    }
    componentWillUnmount() {
        const { user, dispatch } = this.props;
        const { vcsRefetchSyncTimeout } = this.state;
        if (user.invitedOrganization) {
            dispatch({ type: CLEAR_INVITED_ORGANIZATION });
        }
        if (vcsRefetchSyncTimeout) {
            clearTimeout(vcsRefetchSyncTimeout);
            this.setState({ vcsRefetchSyncTimeout: null });
        }
    }
    async fetchRepositoryList(reload = false, retryCount = 1) {
        const { repositories, dispatch, user } = this.props;
        if (!isRepositoryListEmpty(repositories) && !reload && user.user?.fetchedRepositoriesProgress === 1) {
            this.setState({ loading: false });
            return;
        }
        this.setState({ loading: true });
        try {
            const repositoryList = await this.context.getRepositoryList(reload);
            if (repositoryList) {
                dispatch({ type: types.CLEAR_REPOSITORIES });
                dispatch({
                    type: types.BULK_RELOAD_REPOSITORIES,
                    payload: repositoryList,
                });
                const repositoriesCount = Object.keys(repositories.list)
                    .map((vcs) => Object.keys(repositories.list[vcs]).length)
                    .reduce((total, count) => (total += count), 0);
                if (repositoriesCount === 0 && !reload) {
                    this.fetchRepositoryList(true);
                }
                else if (user.user?.fetchedRepositoriesProgress !== 1 && retryCount < 5) {
                    const vcsRefetchSyncTimeout = setTimeout(() => this.fetchRepositoryList(reload, ++retryCount), 3 * 1000);
                    // @ts-expect-error TS2322: Type 'Timeout' is not assignable to type 'number'.
                    this.setState({ vcsRefetchSyncTimeout });
                }
                else {
                    this.setState({ loading: false });
                }
            }
        }
        catch (error) {
            if (retryCount < 3) {
                setTimeout(() => this.fetchRepositoryList(reload, ++retryCount), (retryCount - 1) * 1000);
            }
            else {
                this.setState({ loading: false });
            }
            throw error;
        }
    }
    renderMetrics(loading = true) {
        const { user } = this.props;
        const duration = 29; // days
        let from = startOfDay(subDays(new Date(), duration));
        from = addMinutes(from, timezoneOffsetCalculation(from, user.user.timezoneId));
        let to = endOfDay(new Date());
        to = addMinutes(to, timezoneOffsetCalculation(to, user.user.timezoneId));
        return (_jsx("div", { className: !IS_APP_CODEAC ? '' : 'pt-3', children: _jsx(PrMetrics, { from: from, to: to, loading: loading, showTimeInfo: true, isClickable: true }) }));
    }
    renderHeader(totalRepositoriesCount, showNoAccessMessage) {
        const { user, repositories, history, dispatch, t } = this.props;
        const { loading } = this.state;
        const showInvitation = user.invitedOrganization && user.user;
        const noAccess = !!(showNoAccessMessage && !loading && totalRepositoriesCount);
        const showGhaNotInstalled = !loading && user.user && user.user.gha && !user.user.ghaInstallations.length && totalRepositoriesCount;
        return (_jsxs(_Fragment, { children: [showInvitation && _jsx("div", { className: "mb-0 pt-2", children: _jsx(Invitation, { user: user, dispatch: dispatch }) }), user.user && _jsx(MaintenanceBanner, { vcs: user.user.vcs, className: "maintenance-banner--in-container" }), !IS_APP_CODEAC && _jsx("h2", { className: "repositories__service", children: t('myRepositories') }), user.user && IS_APP_CODEAC && this.renderMetrics(loading), noAccess && (_jsxs("div", { className: "alert alert-warning", role: "alert", children: [_jsx("h5", { children: t('noAccess') }), t('noAccessMessage', { siteName: t('siteName') })] })), _jsxs("div", { className: "row", children: [_jsx("div", { className: "col col-10 col-md-8", children: totalRepositoriesCount !== 0 && _jsx(Search, { search: location.search, history: history, repositories: repositories, dispatch: dispatch }) }), _jsx("div", { className: "col col-2 col-md-4", children: _jsx("div", { className: "repositories__refresh", children: _jsxs("button", { onClick: () => this.fetchRepositoryList(true), className: "btn btn-outline-secondary", disabled: loading, children: [_jsx(Icon, { name: "sync-alt", className: "mr-md-2", fixedWidth: true, spin: loading }), _jsx("span", { className: "d-none d-md-inline", children: t(loading ? 'refreshing' : 'refresh') })] }) }) })] }), showGhaNotInstalled && (_jsxs("div", { className: "alert alert-warning", role: "alert", children: [_jsx("h5", { children: t('notInstalledGha') }), t('notInstalledGhaMessage'), _jsx("a", { className: "btn btn-primary btn-sm ml-2", href: ghaNewInstallationLink(user.user), rel: "noreferrer", children: t('installGha') })] }))] }));
    }
    getRepositoriesLists() {
        const { repositories } = this.props;
        let enabledRepositories = [];
        let restRepositories = [];
        let totalRepositoriesCount = 0;
        Object.keys(repositories.list).forEach((vcs) => {
            Object.keys(repositories.list[vcs]).forEach((fullName) => {
                const repository = repositories.list[vcs][fullName];
                if (repository.active) {
                    enabledRepositories.push(repository);
                }
                else {
                    restRepositories.push(repository);
                }
                totalRepositoriesCount++;
            });
        });
        restRepositories = restRepositories.filter((repository) => {
            return repository.fullname.toLowerCase().indexOf(repositories.search.toLowerCase()) !== -1;
        });
        enabledRepositories = enabledRepositories.filter((repository) => {
            return repository.fullname.toLowerCase().indexOf(repositories.search.toLowerCase()) !== -1;
        });
        enabledRepositories.sort((first, second) => first.fullname.localeCompare(second.fullname));
        restRepositories.sort((first, second) => first.fullname.localeCompare(second.fullname));
        return {
            enabledRepositories,
            restRepositories,
            totalRepositoriesCount,
        };
    }
    render() {
        const { browser, repositories, user, match, t } = this.props;
        const { loading } = this.state;
        let showNoAccessMessage = true;
        if (user.user) {
            Object.keys(repositories.list).forEach((vcs) => {
                Object.keys(repositories.list[vcs]).forEach((fullName) => {
                    const repository = repositories.list[vcs][fullName];
                    if (repository.hookUid || repository?.admins.length) {
                        showNoAccessMessage = false;
                    }
                });
            });
        }
        const { enabledRepositories, restRepositories, totalRepositoriesCount } = this.getRepositoriesLists();
        const noRepositories = !loading && totalRepositoriesCount === 0;
        const noSearchResults = repositories.search && !enabledRepositories.length && !restRepositories.length;
        const showGrid = IS_APP_CODEAC;
        return (_jsxs(Layout, { loginRequired: true, title: t('repositories'), match: match, titlePrimary: t('myRepositories'), children: [_jsxs("div", { className: "container repositories__container", children: [this.renderHeader(totalRepositoriesCount, showNoAccessMessage), _jsxs("div", { className: "repositories__items", "data-testid": "repository-list", children: [_jsx(RepositoriesList, { allowInstallGha: user?.user?.gha && user?.user?.fetchedRepositoriesProgress === 1, gha: !!user.user?.gha, list: enabledRepositories, onRegisterWebhook: this.handleRegisterWebhook, showGrid: showGrid && browser.greaterThan.small }), _jsx(RepositoriesList, { allowInstallGha: user?.user?.gha && user?.user?.fetchedRepositoriesProgress === 1, gha: !!user.user?.gha, list: restRepositories, onRegisterWebhook: this.handleRegisterWebhook, showGrid: showGrid && browser.greaterThan.small, userId: user?.user?.id })] }), noRepositories && _jsx(NoRepositories, { vcs: user.user?.vcs }), noSearchResults && totalRepositoriesCount > 0 && _jsx("div", { children: t('noRepositoryFound_plural') }), loading && !totalRepositoriesCount ? (_jsxs("div", { className: IS_APP_CODEAC ? 'loading-container' : 'text-center', children: [IS_APP_CODEAC ? (_jsx("div", { className: "repository__loader", children: _jsx(LoadingPlaceholder, { type: "repository", count: 10 }) })) : (_jsx(Icon, { name: "spinner", pulse: true, fixedWidth: true, size: "3x", className: "repositories__spinner" })), _jsxs("span", { className: "sr-only", children: [t('loading'), "..."] })] })) : null, !loading && (_jsx("div", { className: "mt-4 content--center", children: !!user.user?.gha && user.user?.ghaInstallations && user.user?.ghaInstallations.length ? (_jsxs(Trans, { i18nKey: "missingRepositoryGha", values: { email: SUPPORT_EMAIL }, children: ["\u2014 Didn't find the repository you are looking for? Check if you gave permission to desired repository in ", _jsx(Link, { to: "/settings/gha", children: "GitHub App setting" }), ". For more info, please contact us at", ' ', _jsx("a", { href: `mailto:${SUPPORT_EMAIL}`, children: SUPPORT_EMAIL }), "."] })) : (_jsxs(Trans, { i18nKey: "missingRepository", values: { email: SUPPORT_EMAIL }, children: ["\u2014 Didn't find the repository you are looking for? Check if you gave us permission to access it here. For more info, please contact us at ", _jsx("a", { href: `mailto:${SUPPORT_EMAIL}`, children: SUPPORT_EMAIL }), "."] })) }))] }), _jsx(Setup, { loading: loading }), _jsx(ScrollToTop, { showUnder: 160, style: { zIndex: 10 }, children: _jsx(Icon, { name: "up", className: "scroll-up", onClick: this.handleScrollUp }) })] }));
    }
}
RepositoriesPage.contextType = ApiV2ModelContext;
const mapStateToProps = (state) => ({
    browser: state.browser,
    repositories: state.repositories,
    user: state.user,
    repository: state.repository,
});
const mapDispatchToProps = (dispatch) => ({
    dispatch: dispatch,
});
// @ts-expect-error TS2345: Argument of type 'typeof RepositoriesPage' is not assignable to parameter of type
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(withApollo(RepositoriesPage)));
